import { render, staticRenderFns } from "./EstimatesOldListItem.vue?vue&type=template&id=2afaa338&"
import script from "./EstimatesOldListItem.vue?vue&type=script&lang=js&"
export * from "./EstimatesOldListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports